const subscribers = [];

const dispatchToSubscribers = (mutation, value) => {
  subscribers.forEach((item) => {
    if (item.mutation === mutation) {
      item.callback(value);
    }
  });
};

const subscribeToMutation = (mutation, callback) => {
  subscribers.push({
    mutation,
    callback
  });
};

const unSubscribeFromMutation = (mutation, callback) => {
  const subscriberIndex = subscribers.findIndex((item) => item.callback === callback);

  if (subscriberIndex) {
    subscribers.splice(subscriberIndex,1);
  }
};

const loadingPromise = (mutation) => {
  return new Promise((resolve, reject) => {
    let resolvePromise = (state) => {
      if (state === false) {
        resolve();
        unSubscribeFromMutation(mutation, resolvePromise);
      }
    };

    subscribeToMutation(mutation, resolvePromise);
    setTimeout(resolve, 10000);
  });
}

export {
  dispatchToSubscribers,
  unSubscribeFromMutation,
  subscribeToMutation,
  loadingPromise,
}